import { createApp } from "vue";
import App from "./ImageUpload.vue";
import { init as analytics } from "../../common/analytics";
import widgetTypes from "@/common/consts/widgetTypes.js";

import "./style.scss";
import { initDevMode } from "@/dev/dev.init";

window.frisbuy = window.frisbuy || {};
window.frisbuy.widgets = window.frisbuy.widgets || {};

window.iuWidget = window.frisbuy.widgets.imageUpload = {
  ...window.frisbuy.widgets.imageUpload,
  open() {
    const { imageUpload } = window.frisbuy.widgets;
    const { popup, settings } = imageUpload;

    settings.widgetType = widgetTypes.IMAGE_UPLOAD;

    if (!popup) {
      const propsData = {
        propSettings: settings,
      };

      const iuWidgetInstance = createApp(App, propsData);

      imageUpload.popup = iuWidgetInstance;

      document.body.insertAdjacentHTML(
        "beforeEnd",
        '<div class="iu-widget"></div>'
      );

      const widgetElement = document.querySelector(".iu-widget");

      iuWidgetInstance.mount(widgetElement);
    }

    document.dispatchEvent(new CustomEvent("frisbuy:iu-open"));
  },
  openGuide() {
    const { imageUpload } = window.frisbuy.widgets;
    const { popup, settings } = imageUpload;

    if (popup) {
      popup.isShow = true;
      popup.isGuidlineOpen = true;
    } else {
      const propsData = {
        settings,
      };

      const iuWidgetInstance = createApp(App, propsData);

      imageUpload.popup = iuWidgetInstance;

      document.body.insertAdjacentHTML(
        "beforeEnd",
        '<div class="iu-widget"></div>'
      );

      const widgetElement = document.querySelector(".iu-widget");

      iuWidgetInstance.mount(widgetElement);
      imageUpload.popup.isGuidlineOpen = true;
    }

    document.dispatchEvent(new CustomEvent("frisbuy:iu-open"));
  },
};

document.body.setAttribute("widget-iu-loaded", "true");

if (process.env.NODE_ENV === "development") {
  window.iuWidget.settings = {
    env: "prod",
    analytics: {
      ga: {
        clientHasGa: true,
        sendToClient: false,
        frisbuyTrackerId: "UA-9965,6365-2",
        clientTrackerId: null,
      },
      ga4: {
        frisbuyTrackerId: null,
        clientTrackerId: null,
      },
      ym: {
        clientCounterId: null,
      },
    },
    embedId: "e0e9dc37-edd4-11ea-9365-0242ac130002",
    srcDomain: "https://beta.frisbuy.com",
    separateData: true,
    logged_in_id: null,
    logged_in_email: null,
    sku: "123",
    group: "332",
    profile: { jsBundles: 0.017716169357299805 },
  };
}

if (process.env.NODE_ENV === "development") {
  initDevMode();
}

if (window.iuWidget.settings) {
  analytics(window.iuWidget.settings);
}
